module.exports = __webpack_public_path__ + "img/menu-mobile-close.8e2e4a01.svg";